jQuery(function ($){

  sliceText(
    $('.excerpt')
  )

  function sliceText (text) {

   if( $(window).width() < 376 ) {

      text.text(function(i, text) {

        if (text.length >= 80) {
          text = text.substring(0, 80);
          var lastIndex = text.lastIndexOf(" ");       
          text = text.substring(0, lastIndex) + '...'; 
        }
        
        $(this).text(text);
        
      });

    }

  }

});
